// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Pager INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from "../../Display/Icon";
import Count from "./components/Count";
var Pager = function Pager(props) {
  var id = props.id,
    className = props.className,
    style = props.style,
    countRight = props.countRight,
    disabled = props.disabled,
    hideCount = props.hideCount,
    onNextClick = props.onNextClick,
    onPrevClick = props.onPrevClick,
    _props$paging = props.paging,
    current_page = _props$paging.current_page,
    next_page = _props$paging.next_page,
    prev_page = _props$paging.prev_page,
    per = _props$paging.per,
    total_count = _props$paging.total_count;
  var prevBtnLabel = 'Previous Page';
  var nextBtnLabel = 'Next Page';
  var pagerContainerClass = function pagerContainerClass() {
    return classNames({
      'ui-pager': true
    }, className);
  };
  var actionsClass = function actionsClass() {
    return classNames({
      'ui-pager__actions': true,
      'ui-pager__actions--left': !countRight,
      'ui-pager__actions--right': countRight
    });
  };
  var nextBtnClass = function nextBtnClass() {
    return classNames({
      'ui-pager__btn': true,
      'ui-pager__btn-next': true,
      'ui-pager__btn--disabled': !next_page || disabled
    });
  };
  var prevBtnClass = function prevBtnClass() {
    return classNames({
      'ui-pager__btn': true,
      'ui-pager__btn-prev': true,
      'ui-pager__btn--disabled': !prev_page || disabled
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: pagerContainerClass(),
    style: style
  }, !hideCount && !countRight && /*#__PURE__*/React.createElement(Count, {
    currentPage: current_page,
    per: per,
    totalCount: total_count
  }), /*#__PURE__*/React.createElement("div", {
    className: actionsClass()
  }, /*#__PURE__*/React.createElement("button", {
    tabIndex: 0,
    className: prevBtnClass(),
    id: id,
    "aria-label": prevBtnLabel,
    disabled: !prev_page || disabled,
    onClick: onPrevClick,
    style: style
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCaretLeft",
    size: 10
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Previous Page")), /*#__PURE__*/React.createElement("button", {
    tabIndex: 0,
    className: nextBtnClass(),
    id: id,
    "aria-label": nextBtnLabel,
    disabled: !next_page || disabled,
    onClick: onNextClick,
    style: style
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCaretRight",
    size: 10
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Next Page"))), !hideCount && countRight && /*#__PURE__*/React.createElement(Count, {
    currentPage: current_page,
    per: per,
    totalCount: total_count
  }));
};
Pager.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** If true, pagination counter is on the right. */
  countRight: PropTypes.bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** If true, buttons are disabled. */
  disabled: PropTypes.bool.isRequired,
  /** If true, pagination counter is hidden. */
  hideCount: PropTypes.bool,
  /** Callback function when the next button is clicked */
  onNextClick: PropTypes.func.isRequired,
  /** Callback function when the previous button is clicked */
  onPrevClick: PropTypes.func.isRequired,
  /** paging object with paginatin information */
  paging: PropTypes.object.isRequired
};
Pager.defaultProps = {
  id: '',
  className: '',
  countRight: false,
  disabled: false,
  hideCount: false,
  style: {}
};
export default Pager;